<template>
  <div v-if="start">
    <div v-if="!currentChannel">
      <p>Такой группы не существует</p>
    </div>
    <div v-else class="lg:w-3/4">
      <vx-card class="lg:p-8 w-full mb-6">
        <div v-if="currentChannel" class="mb-10">
          <router-link
            :to="{name: 'channels_edit', params: {channelSlug: currentChannel.slug}}">
            <vs-icon
              icon-pack="feather"
              icon="icon-arrow-left"
            />
            Вернуться назад
          </router-link>
        </div>
        <div class="vx-card__title mb-10">
          <h4 class="mb-4">Интеграция с CallTouch</h4>
          <p>С помощью этой интеграции, Yolker может отправлять новые и повторные обращения в сервис коллтрекинга Calltouch. При успешном подключении, мы отправим тестовую заявку с пользователем "Yolker".</p>
          <br>
          <p>Данные для подключения находятся в Calltouch в разделе Интеграции → Отправка данных во внешние системы → API и Webhooks</p>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="ID личного кабинета: *"
              v-validate="'required'"
              name="site_id"
              v-model="settings.settings.site_id"
            />
            <span class="text-danger text-sm" v-show="errors.has('site_id')">{{ errors.first('site_id') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Токен: *"
              v-validate="'required'"
              name="token"
              v-model="settings.settings.access_token"
            />
            <span class="text-danger text-sm" v-show="errors.has('token')">{{ errors.first('token') }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Название формы: *"
              name="form_name"
              placeholder="Данные из Yolker"
              v-validate="'required'"
              v-model="settings.settings.form_name"
            />
            <span class="text-danger text-sm" v-show="errors.has('form_name')">{{ errors.first('form_name') }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="flex items-center">
              <div class="mr-4">Активировать интеграцию:</div>
              <vs-switch
                v-model="settings.enabled"
              />
            </div>
          </div>
        </div>
        <div class="flex justify-end">
          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            @click.prevent="submitConnect">
            Подключить
          </vs-button>
        </div>
      </vx-card>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { copyObject } from '../../helpers/helpers'
import errorsParsing from '../../mixins/errorsParsing'
import Channels from '../../api/http/models/channels/Channels'
import CallTouchService from '../../api/http/models/calltouch/CallTouchService'
import CallTouchPayloadCast from '../../api/http/models/calltouch/CallTouchPayloadCast'

export default {
  data () {
    return {
      start: false,
      currentChannel: null,
      settings: {
        ...copyObject(CallTouchPayloadCast)
      }
    }
  },
  computed: mapGetters(['authUserCompany']),
  mixins: [errorsParsing],
  async created () {
    const response = await Channels.getOne(this.authUserCompany.slug, this.$route.params.channelSlug)
    this.currentChannel = response.data || null
    this.start = true
  },
  methods: {
    async submitConnect () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        const response = await CallTouchService.create(this.authUserCompany.slug, this.currentChannel.slug, this.settings)

        if (response.status === 'success') {
          this.$router.push({name: 'channels_edit', params: {channelSlug: this.currentChannel.slug}})
        } else if (response.status === 'no_changes') {
          this.$vs.notify({
            color: 'warning',
            title: 'CallTouch уже существует',
            text: ''
          })
        } else if (response.errors) {
          this.errorsParsing(response.errors)
        }
      }
    }
  }
}
</script>
